export const GET_SENTIMENT_WORDCLOUD_WATCHER =
  "app/ReportsV2/WidgetQualitativeBubbles/GET_SENTIMENT_WORDCLOUD_WATCHER"
export const GET_SENTIMENT_WORDCLOUD_SUCCESS =
  "app/ReportsV2/WidgetQualitativeBubbles/GET_SENTIMENT_WORDCLOUD_SUCCESS"
export const GET_SENTIMENT_WORDCLOUD_FAILED =
  "app/ReportsV2/WidgetQualitativeBubbles/GET_SENTIMENT_WORDCLOUD_FAILED"

export const GET_QUALITATIVE_QUESTIONS_WATCHER =
  "app/ReportsV2/WidgetQualitativeBubbles/GET_QUALITATIVE_QUESTIONS_WATCHER"
export const GET_QUALITATIVE_QUESTIONS_SUCCESS =
  "app/ReportsV2/WidgetQualitativeBubbles/GET_QUALITATIVE_QUESTIONS_SUCCESS"
export const GET_QUALITATIVE_QUESTIONS_FAILED =
  "app/ReportsV2/WidgetQualitativeBubbles/GET_QUALITATIVE_QUESTIONS_FAILED"
